import { render, staticRenderFns } from "./discrimination-dialog-age.vue?vue&type=template&id=4cb9e327&scoped=true"
import script from "./discrimination-dialog-age.vue?vue&type=script&lang=js"
export * from "./discrimination-dialog-age.vue?vue&type=script&lang=js"
import style0 from "./discrimination-dialog-age.vue?vue&type=style&index=0&id=4cb9e327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9e327",
  null
  
)

export default component.exports